(() => {
  // The original Motion header bootstrapped its cart drawer. Keep that behavior
  // when using the replacement header section.
  if (window.theme?.CartDrawer && window.theme.settings.cartType === 'drawer' && !window.oglCartDrawer) {
    window.oglCartDrawer = new window.theme.CartDrawer();
  }
  const init = (scope = document) => {
    scope.querySelectorAll('[data-ogl-dropdown]').forEach(dropdown => {
      if (dropdown.dataset.ready) return;
      dropdown.dataset.ready = 'true';
      const toggle = dropdown.querySelector('[data-ogl-dropdown-toggle]');
      const panel = dropdown.querySelector('[data-ogl-dropdown-panel]');
      const position = () => {
        const rect = toggle.getBoundingClientRect();
        const width = Math.min(340, innerWidth - 32);
        panel.style.width = width + 'px';
        panel.style.left = Math.max(16, Math.min(rect.left, innerWidth - width - 16)) + 'px';
        panel.style.top = (rect.bottom + 6) + 'px';
        panel.style.maxHeight = Math.max(100, Math.min(440, innerHeight - rect.bottom - 22)) + 'px';
      };
      const close = () => {
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      };
      const open = () => {
        position();
        panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      };
      toggle.addEventListener('click', () => panel.hidden ? open() : close());
      toggle.addEventListener('keydown', e => {
        if (e.key === 'ArrowDown') { e.preventDefault(); open(); panel.querySelector('a')?.focus(); }
      });
      dropdown.addEventListener('keydown', e => {
        if (e.key === 'Escape' && !panel.hidden) { e.preventDefault(); close(); toggle.focus(); }
      });
      dropdown.addEventListener('focusout', e => { if (!dropdown.contains(e.relatedTarget)) close(); });
      document.addEventListener('pointerdown', e => { if (!dropdown.contains(e.target)) close(); });
      window.addEventListener('resize', close);
      window.addEventListener('scroll', close, { passive: true });
      dropdown.closest('.nav')?.addEventListener('scroll', close, { passive: true });
    });
    scope.querySelectorAll('[data-ogl-theme]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const dark = document.documentElement.dataset.oglTheme !== 'dark';
        document.documentElement.dataset.oglTheme = dark ? 'dark' : 'light';
        button.setAttribute('aria-pressed', String(dark));
      });
    });
    scope.querySelectorAll('[data-ogl-shop]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const cards = [...root.querySelectorAll('[data-ogl-card]')];
      const search = root.querySelector('[data-ogl-search]');
      const brandSelect = root.querySelector('[data-ogl-brand]');
      const sort = root.querySelector('[data-ogl-sort]');
      const grid = root.querySelector('[data-ogl-grid]');
      const empty = root.querySelector('[data-ogl-empty]');
      const params = new URLSearchParams(location.search);
      if (brandSelect && [...brandSelect.options].some(o => o.value === params.get('brand'))) brandSelect.value = params.get('brand');
      const brandDirectory = root.querySelector('[data-ogl-brands]');
      if (brandDirectory && location.hash === '#merken') brandDirectory.open = true;
      let filter = params.has('budget') ? 'budget' : params.get('category') || 'all';
      const categories = ['Supplementen', 'Verzorging', 'Make-up', 'Lichaamsverzorging', 'Gezichtsverzorging', 'Mondverzorging', 'Bad & Douche', 'Huidverzorging'];
      if (!['all', 'budget', 'new', ...categories].includes(filter)) filter = 'all';
      const render = () => {
        let count = 0;
        const term = search.value.trim().toLowerCase();
        const ordered = [...cards];
        if (sort.value === 'low') ordered.sort((a, b) => +a.dataset.price - +b.dataset.price);
        if (sort.value === 'high') ordered.sort((a, b) => +b.dataset.price - +a.dataset.price);
        if (sort.value === 'name') ordered.sort((a, b) => a.dataset.title.localeCompare(b.dataset.title, 'nl'));
        ordered.forEach(card => {
          const d = card.dataset;
          const categoryMatch = d.category === filter
            || (filter === 'Lichaamsverzorging' && ['Bad & Douche', 'Huidverzorging'].includes(d.bodySubcategory))
            || (['Bad & Douche', 'Huidverzorging'].includes(filter) && d.bodySubcategory === filter)
            || (filter === 'Gezichtsverzorging' && d.alsoFace === 'true')
            || (filter === 'Verzorging' && ['Verzorging', 'Lichaamsverzorging', 'Gezichtsverzorging', 'Mondverzorging', 'Haarverzorging', 'Intieme verzorging'].includes(d.category));
          const match = (filter === 'all' || (filter === 'budget' ? +d.price < +root.dataset.budget : filter === 'new' ? d.new === 'true' : categoryMatch)) && d.title.toLowerCase().includes(term)
            && (!brandSelect?.value || d.vendor === brandSelect.value);
          card.hidden = !match;
          if (match) count++;
          grid.insertBefore(card, empty);
        });
        empty.hidden = count > 0;
        root.querySelector('[data-ogl-count]').textContent = `${count} ${root.dataset.resultLabel}`;
        root.querySelectorAll('[data-ogl-filter]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.oglFilter === filter)));
        root.querySelectorAll('[data-ogl-brand-link]').forEach(a => {
          if (brandSelect?.value === a.dataset.oglBrandLink) a.setAttribute('aria-current', 'true');
          else a.removeAttribute('aria-current');
        });
      };
      const syncUrl = () => {
        const url = new URL(location.href);
        url.searchParams.delete('budget');
        url.searchParams.delete('category');
        url.searchParams.delete('brand');
        if (brandSelect?.value) url.searchParams.set('brand', brandSelect.value);
        if (filter === 'budget') url.searchParams.set('budget', String(+root.dataset.budget / 100));
        else if (filter !== 'all') url.searchParams.set('category', filter);
        history.replaceState(null, '', url);
      };
      root.querySelectorAll('[data-ogl-filter]').forEach(b => b.addEventListener('click', () => { filter = b.dataset.oglFilter; syncUrl(); render(); }));
      search.addEventListener('input', render);
      sort.addEventListener('change', render);
      brandSelect?.addEventListener('change', () => { syncUrl(); render(); });
      root.querySelectorAll('[data-ogl-brand-link]').forEach(a => a.addEventListener('click', e => {
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        brandSelect.value = a.dataset.oglBrandLink;
        filter = 'all';
        search.value = '';
        syncUrl();
        render();
      }));
      root.querySelector('[data-ogl-reset]').addEventListener('click', () => { filter = 'all'; search.value = ''; sort.value = 'selected'; if (brandSelect) brandSelect.value = ''; syncUrl(); render(); });
      render();
      if (location.hash.includes('ogl-search')) search.focus();
    });
  };
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  ['cart:updated', 'ajaxProduct:added'].forEach(type => document.addEventListener(type, () => {
    fetch((window.Shopify?.routes?.root || '/') + 'cart.js').then(r => r.json()).then(cart => document.querySelectorAll('[data-ogl-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = !cart.item_count; })).catch(() => {});
  }));
})();
